//跳转到帮助文档
export const open = (url:number, enUrl:number, zIndex:number = 1000) => {
    if (!url || !enUrl) {
        return;
    }
    __ksStorage__.docSet({
        indexUrl: `//docs.ksyun.com/documents/${url}`,
        indexEnUrl: `//endocs.ksyun.com/documents/${enUrl}`,
        zIndex
    });
}
